import {Injectable} from '@angular/core';
import {Subject} from "rxjs/Subject";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {Observable} from "rxjs";


@Injectable()
export class ModalManagementService {

  private approveBtnIsDisabled$: Subject<boolean> = new BehaviorSubject(false);
  private modalDataIsChanged$: Subject<boolean> = new BehaviorSubject(false);
  private _discardDataOnClickOutside: boolean = true;

  constructor() {
  }


  get discardDataOnClickOutside(): boolean {
    return this._discardDataOnClickOutside;
  }

  setDiscardDataOnClickOutside(value: boolean) {
    this._discardDataOnClickOutside = value;
  }

  disableApproveButton() {
    this.approveBtnIsDisabled$.next(true);
  }

  enableApproveButton() {
    this.approveBtnIsDisabled$.next(false);
  }

  resetData() {
    this.setDiscardDataOnClickOutside(true);
    this.modalDataIsChanged$.next(false);
  }

  dataIsChanged() {
    this.modalDataIsChanged$.next(true);
  }

  approveButtonIsDisabled(): Observable<boolean> {
    return this.approveBtnIsDisabled$.asObservable().take(1);
  }

  modalDataIsChanged(): Observable<boolean> {
    return this.modalDataIsChanged$.asObservable().take(1);
  }

  triggerFunction(callback: any, args?: any) {
    if (callback && typeof callback === 'function') {
      if (args !== undefined)
        callback(...args).bind(this);
    } else {
      callback().bind(this);
    }
  }
}

